import { useEffect, useState } from 'react';

/**
 * Custom hook that returns true during the initial render of a component,
 * and false on subsequent renders. This is useful for disabling animations
 * that would otherwise run when a component first mounts or when its initial state
 * (potentially derived from props or other runtime conditions) is established.
 */
export function useInitialRenderFlag(): boolean {
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    useEffect(() => {
        // Defer setting isInitialLoad to false until after the current event loop tick.
        // This gives other state updates (like those from Redux selectors on initial load)
        // a chance to be processed and rendered while isInitialLoad is still true.
        const timer = setTimeout(() => {
            setIsInitialLoad(false);
        }, 0);

        return () => clearTimeout(timer);
    }, []);

    return isInitialLoad;
}
